<template>
  <div class="flight-direction-comparison">
    <section class="flight-comparison-summary" aria-label="Comparison summary">
      <div>
        <strong>{{ rows.length }} fields</strong>
        <span class="flight-comparison-summary__matching">{{ matchingRows.length }} matching</span>
        <span class="flight-comparison-summary__review" :class="{ 'flight-comparison-summary__review--empty': !conflictRows.length }">
          {{ conflictRows.length }} {{ conflictRows.length === 1 ? 'needs' : 'need' }} review
        </span>
      </div>
      <span>{{ changeCount }} client {{ changeCount === 1 ? 'change' : 'changes' }}</span>
    </section>

    <section v-if="conflictRows.length" class="flight-comparison-section">
      <header class="flight-comparison-section__header">
        <div><span>Needs review</span><strong>Choose the final value for each difference</strong></div>
        <span>{{ conflictRows.length }} {{ conflictRows.length === 1 ? 'field' : 'fields' }}</span>
      </header>
      <article v-for="row in conflictRows" :key="`review-${row.key}`" class="flight-comparison-row flight-comparison-row--expanded">
        <header><strong>{{ row.label }}</strong><app-status-badge design="new" label="Needs review" tone="amber" compact /></header>
        <div class="flight-comparison-row__decision">
          <button type="button" class="flight-comparison-source" :class="{ 'flight-comparison-source--selected': row.matchesClient }" @click="$emit('use-value', row.key, 'client')">
            <small>Client</small><strong>{{ row.clientDisplay }}</strong><span>Use client</span>
          </button>
          <button type="button" class="flight-comparison-source" :class="{ 'flight-comparison-source--selected': row.matchesAi }" @click="$emit('use-value', row.key, 'ai')">
            <small>AI extraction</small><strong>{{ row.aiDisplay }}</strong><span>Use AI</span>
          </button>
          <div class="flight-comparison-row__final">
            <div><small>Final reviewed</small><span>{{ row.reviewedSourceLabel }}</span></div>
            <reviewed-value-control :field-key="row.key" :value="row.reviewedValue" :airports="airports" @input="$emit('set-value', row.key, $event)" />
          </div>
        </div>
        <p v-if="row.issue" class="flight-comparison-row__issue">{{ row.issue.description }}</p>
      </article>
    </section>

    <section v-else class="flight-comparison-success">
      <span aria-hidden="true">✓</span>
      <div><strong>Client and AI values match</strong><p>No differences require a decision. Open matching fields only if a manual correction is needed.</p></div>
    </section>

    <section v-if="matchingRows.length" class="flight-matching-fields">
      <button type="button" class="flight-matching-fields__toggle" :aria-expanded="showMatching ? 'true' : 'false'" @click="$emit('update:show-matching', !showMatching)">
        <span>{{ showMatching ? 'Hide' : 'Show' }} {{ matchingRows.length }} matching {{ matchingRows.length === 1 ? 'field' : 'fields' }}</span>
        <svg viewBox="0 0 20 20" aria-hidden="true" :class="{ 'flight-matching-fields__chevron--open': showMatching }"><path d="m5 7.5 5 5 5-5" /></svg>
      </button>
      <div v-if="showMatching" class="flight-matching-fields__table" role="table">
        <div class="flight-matching-fields__columns" role="row"><span>Field</span><span>Client</span><span>AI</span><span>Final reviewed</span><span>Status</span></div>
        <article v-for="row in matchingRows" :key="`matching-${row.key}`" class="flight-matching-row" role="row">
          <strong>{{ row.label }}</strong>
          <div class="flight-matching-row__value"><small>Client</small><span>{{ row.clientDisplay }}</span></div>
          <div class="flight-matching-row__value"><small>AI</small><span>{{ row.aiDisplay }}</span></div>
          <div class="flight-matching-row__final">
            <small>Final reviewed</small>
            <span v-if="!editingFields.includes(row.key)">{{ row.reviewedDisplay }}</span>
            <reviewed-value-control v-else :field-key="row.key" :value="row.reviewedValue" :airports="airports" @input="$emit('set-value', row.key, $event)" />
          </div>
          <button type="button" class="flight-matching-row__action" @click="$emit('toggle-edit', row.key)">
            <span v-if="!editingFields.includes(row.key)" aria-hidden="true">✓</span>{{ editingFields.includes(row.key) ? 'Done' : 'Edit' }}
          </button>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import ReviewedValueControl from './ReviewedValueControl'

export default {
  name: 'FlightDirectionComparisonPanel',
  components: { ReviewedValueControl },
  props: {
    rows: { type: Array, required: true },
    conflictRows: { type: Array, required: true },
    matchingRows: { type: Array, required: true },
    changeCount: { type: Number, required: true },
    airports: { type: Array, default: () => [] },
    showMatching: Boolean,
    editingFields: { type: Array, default: () => [] }
  }
}
</script>
